import React, { ChangeEvent } from "react";
import { toast } from "react-toastify";
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { AgreeTerms, CVVNumber, CardHolder, CardNumber, Continue, Expiration, Previous } from "../../../../../../../constants";
import { ActiveCallbackProp, PayDetailsFormType } from "../../../../../../../types/Forms";
import { ListOfYears } from "../../../../../../../data/formsAndTable/forms/FormLayout";
import { useForm } from "react-hook-form";

const PayDetailsForm: React.FC<ActiveCallbackProp> = ({ activeCallBack }) => {
  const {
    register,
    formState: { errors },
    setValue,
    watch,
    handleSubmit,
  } = useForm({
    defaultValues: { cardHolderName: "", cardNumber: "", expiryDate: "", expiryYear: "", cvvNumber: "", agreeTerms: false },
  });

  const formData = watch();
  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    let name = event.target.name as keyof typeof PayDetailsFormType;
    let value = name === "agreeTerms" ? event.target.checked : event.target.value;
    setValue(name, value, { shouldValidate: true, shouldDirty: true });
  };

  const handleNextButton = handleSubmit(
    () => {
      if (formData.cardHolderName !== "" && formData.cardNumber !== "" && formData.expiryDate !== "" && formData.expiryYear !== "" && formData.cvvNumber !== "" && formData.agreeTerms !== false) activeCallBack(5);
    },
    () => {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  );
  return (
    <Form onSubmit={(event) => event.preventDefault()} className="needs-validation" noValidate>
      <Row className="g-3">
        <Col md="6">
          <Label>{CardHolder}</Label>
          <Input {...register("cardHolderName", { required: "CardHolder name is required" })} value={formData.cardHolderName} onChange={updateFormData} type="text" />
          {errors.cardHolderName && <span className="text-danger">{errors.cardHolderName.message}</span>}
        </Col>
        <Col md="6">
          <Label>{CardNumber}</Label>
          <Input {...register("cardNumber", { required: "Card number is required" })} value={formData.cardNumber} onChange={updateFormData} type="number" placeholder="xxxx xxxx xxxx xxxx" />
          {errors.cardNumber && <span className="text-danger">{errors.cardNumber.message}</span>}
        </Col>
        <Col xs="12">
          <Row className="g-3">
            <Col md="6">
              <Label>{Expiration}</Label>
              <Row className="g-3">
                <Col md="6">
                  <Input {...register("expiryDate", { required: "Expiry Date is required" })} id="expiration" type="number" required placeholder="xx/xx" value={formData.expiryDate} onChange={updateFormData} />
                  {errors.expiryDate && <span className="text-danger">{errors.expiryDate.message}</span>}
                </Col>
                <Col md="6">
                  <Input {...register("expiryYear", { required: "Expiry Year is required" })} value={formData.expiryYear} type="select" onChange={updateFormData} className="f-w-400 f-14 text-gray">
                    <option value="" disabled>
                      {"Year"}
                    </option>
                    {ListOfYears.map((data, index) => (
                      <option key={index} value={data}>
                        {data}
                      </option>
                    ))}
                  </Input>
                  {errors.expiryYear && <span className="text-danger">{errors.expiryYear.message}</span>}
                </Col>
              </Row>
            </Col>
            <Col md="6">
              <Label>{CVVNumber}</Label>
              <Input {...register("cvvNumber", { required: "Organization name is required" })} type="number" required value={formData.cvvNumber} onChange={updateFormData} />
              {errors.cvvNumber && <span className="text-danger">{errors.cvvNumber.message}</span>}
            </Col>
          </Row>
        </Col>
        <Col xs="12">
          <FormGroup check className="mb-0">
            <Input id="invalidCheckboxWizard" type="checkbox" {...register("agreeTerms", { required: true })} onChange={updateFormData} required />
            <Label className={`${formData.agreeTerms ? "mb-0" : "text-danger mb-0"}`} htmlFor="invalidCheckboxWizard" check>
              {AgreeTerms}
            </Label>
          </FormGroup>
        </Col>
        <Col xs="12" className="text-end">
          <Button color="primary" className="me-2" onClick={() => activeCallBack(3)}>
            {Previous}
          </Button>
          <Button color="primary" onClick={handleNextButton}>
            {Continue}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default PayDetailsForm;
